export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'accept'
};
